import React from 'react';
import request from 'arcdynamic-request';
import Alert from "../Alert";
import {FIRMS} from "../../consts/tables";
import FirmForm from "../FirmForm/FirmForm";
import { ApolloConsumer } from '@apollo/client';
import { CREATE_UPDATE_FIRM } from '../Graphql/mutations';
import { mutateData } from '../Service/graphQlService';
import { CREATE_OR_UPDATE_COMPANY_FIRM } from '../Graphql/CompanysMutations/allCompanysMutation';

export default class FirmDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
            newFirm: false,
        };
        this.client = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{}});
    }

    handleSubmit(e) {
        e.preventDefault();
         //Added if consition newly earlier it was not there
         if (this.client) {
        this.saveData(this.client);
         }
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    async saveData(client) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        const token = localStorage.getItem('authToken');
        try {
            const payload = {company_type:"Firm",};

            // List of fields to include in the payload
            const fields = [
                "name",
                "address",
                "city",
                "state",
                "phone",
                "parent_firm",
                "website",
                "zip",
                "email"
            ];
            
            // Dynamically add fields to the payload if they exist in `this.state.data`
         fields.forEach((field) => {
           if (this.state.data[field] != null && this.state.data[field] != "")  {
             payload[field] = this.state.data[field];
           }
         });
     if (payload.parent_firm != null && payload.parent_firm !== "") {
       payload.parent_firm = payload.parent_firm.toString();
     }

     if (payload.zip != null && payload.zip !== "") {
       payload.zip = Number(payload.zip);
     }
        // const res = await client.mutate({
        //   mutation: CREATE_UPDATE_FIRM,
        //   variables: {
        //     input: payload
        //   },
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,  // Bearer token added here
        //     },
        //   },
        // })
        const res = await mutateData(CREATE_OR_UPDATE_COMPANY_FIRM,{input: payload})
        // }).then(res => {
        //     if (res && res.success) {
            if (res && res.data.createOrUpdateCompany.success) {
                this.setState({isBusy: false});
                //this.props.savedNewItem(res.data[0]);
                this.props.savedNewItem(res.data.createOrUpdateCompany.company);

                if (this.props.closeChildDrawer) {
                    this.props.closeChildDrawer();
                    setTimeout(() => this.setState({data: {}}), 1000);
                }

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}), 1000);
                }
            } else {
           this.setState({
            isBusy: false,
            error: res.data.createOrUpdateCompany.message || "Failed to save company details",
        });
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
             this.setState({
                    isBusy: null,
                    //error: res && res.message ? res.message : 'Unspecified error',
                    error:  error.message || "Unspecified error",
                });
          }
        
       // });
    }

    render() {
        const data = this.state.data;

        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <React.Fragment>
                <FirmForm data={data}
                          paneIndex={this.state.paneIndex}
                          handleSubmit={this.handleSubmit}
                          handleCancel={this.props.closeDrawer}
                          handleParentChange={this.handleChange}
                          handleParentDropdownChange={this.handleDropdownChange}
                          handlePaneChange={(key) => this.setState({paneIndex: key})}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
            )
        }}

    </ApolloConsumer>
        );
    }
}

